import { EStationVariant } from '@/config/station';

import type { TOption } from '@/types/common';

export const STATION_TYPES: TOption<EStationVariant>[] = [
  {
    label: 'stationSetup.stationType.variants.gasolineAndDiesel',
    value: EStationVariant.GASOLINE_AND_DIESEL,
    disabled: false,
  },
  {
    label: 'stationSetup.stationType.variants.electric',
    value: EStationVariant.ELECTRIC,
    disabled: false,
  },
  {
    label: 'stationSetup.stationType.variants.both',
    value: EStationVariant.BOTH,
    disabled: true,
  },
];
